export const ArticlePublicationStatus = {
  Draft: 0,
  Published: 1,
}

export const ArticlePublicationStatusDisplayName = {
  [ArticlePublicationStatus.Draft]: 'Draft',
  [ArticlePublicationStatus.Published]: 'Published',
}
